import 'whatwg-fetch';
import Vue from 'vue';
import pkg from '../package.json';
import App from './App.vue';

Vue.config.productionTip = false;

const rootElement = document.querySelector('#mozio-app');
const config = JSON.parse(rootElement.getAttribute('data-config'));

window.KW_WIDGET_MOZIO = {
  ver: pkg.version,
  config,
};

new Vue({
  data() {
    return {
      sourceConfig: config,
    };
  },
  render: h => h(App, {
    props: {
      config,
    },
  }),
}).$mount(rootElement);
